<template>
  <div class="pa-4 mb-12">
    <v-row v-if="!loading">
      <empty-state text="No file(s) found." v-show="!hasFiles" />
      <v-col xs="12" sm="12" md="6" lg="4" v-for="(file, i) in files" :key="i">
        <v-card raised @click="onCardClick(file)">
          <!-- <empty-state
            text="No attached file(s) found."
            v-if="file.count === 0"
          />
          <v-img v-else :src="file.files[0].responsive_url"></v-img>
          <v-divider></v-divider> -->
          <v-card-title class="filename">
            <h5>{{ file.name }}</h5>
          </v-card-title>
          <v-card-subtitle class="owner">
            Last update at {{ file.lastUpdate }}
          </v-card-subtitle>
        </v-card>
      </v-col>
      <FileDetails v-model="showFileDetails" @reloadFileList="fetchFiles" />
    </v-row>

    <v-row v-else>
      <v-col xs="12" sm="12" md="6" lg="4" v-for="k in 2" :key="k">
        <v-card raised class="elevation-3">
          <v-card-title class="headline">
            <v-skeleton-loader
              height="40px"
              type="heading"
              width="150px"
              max-width="200px"
            />
          </v-card-title>
          <v-card-subtitle style="height:30px">
            <v-skeleton-loader type="text" width="100" />
          </v-card-subtitle>
          <v-list class="transparent">
            <v-list-item v-for="i in 5" :key="i">
              <v-list-item-subtitle>
                <v-skeleton-loader
                  type="text"
                  :max-width="i % 2 === 0 ? 90 : 75"
                />
              </v-list-item-subtitle>
              <v-list-item-title class="d-flex justify-end">
                <v-skeleton-loader type="text" :width="i % 2 === 0 ? 30 : 50" />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import EmptyState from '@/components/shared/EmptyState'
import FileDetails from './../components/FileDetails'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  props: ['id'],

  components: {
    EmptyState,
    FileDetails
  },

  directives: {
    infiniteScroll
  },

  data() {
    return {
      loading: false,
      showFileDetails: false
    }
  },

  computed: {
    ...mapState({
      files: state => state.file.list,
      listMeta: state => state.file.listMeta
    }),

    hasFiles() {
      return this.files.length > 0
    }
  },

  methods: {
    ...mapActions({
      getFiles: 'file/getFiles',
      getFileDetails: 'file/getFileDetails'
    }),

    ...mapMutations({
      clearFileDetails: 'file/clearFileDetails'
    }),

    async fetchFiles(page = 1) {
      this.showFileDetails = false
      if (this.loading) return
      let params = {
        page: page,
        id: this.id
      }
      this.loading = true
      await this.getFiles(params)
      this.loading = false
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchFiles(this.listMeta.current_page + 1)
      }
    },

    onCardClick(file) {
      if (this.loading) return
      this.loading = true
      this.clearFileDetails()
      this.getFileDetails(file.id)
      this.loading = false
      this.showFileDetails = true
    }
  },

  created() {
    this.fetchFiles()
  }
}
</script>
